import React, { useState } from 'react';
import SideActionBoard from '../../../../../components/SideActionBoard';

import AddParticipant from './AddParticipant';

const Sidebar = ({ openSideActionBoard, setOpenSideActionBoard, onSuccess }) => {
  const { id } = openSideActionBoard;
  return (
    <SideActionBoard setOpenSideActionBoard={setOpenSideActionBoard}>
      <AddParticipant
        id={id}
        setOpenSideActionBoard={setOpenSideActionBoard}
        onSuccess={onSuccess}
      />
    </SideActionBoard>
  );
};

export default Sidebar;